<template>
  <v-badge
    :content="cartItems"
    v-if="cartItems > 0"
    :value="cartItems"
    color="red"
    overlap
  >
    <v-btn class="ml-2 my-2" color="primary" dark :to="{ name: 'CheckOut' }">
      <v-icon left>
        mdi-cart
      </v-icon>
      Check out
    </v-btn>
  </v-badge>
</template>
<script>
export default {
  name: "CheckOutBtn",
  computed: {
    cartItems: function() {
      var result = 0;
      if (this.$store.state.account && this.$store.state.account.children) {
        var childrenLength = this.$store.state.account.children.length;
        for (var i = 0; i < childrenLength; i++) {
          var examRegistrationLength = this.$store.state.account.children[i]
            .examRegistrations.length;
          for (var j = 0; j < examRegistrationLength; j++) {
            if (
              !this.$store.state.account.children[i].examRegistrations[j].isPaid
            ) {
              result++;
            }
          }
        }
      }
      return result;
    }
  }
};
</script>
